import 'custom-event-polyfill';
import 'nodelist-foreach-polyfill';
import 'jquery';

// Import everything from autoload

import 'lazysizes';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/respimg/ls.respimg';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';

/** Populate Router instance with DOM routes */
const routes = new Router({ common, home, archive: home });

// Load Events
document.addEventListener('DOMContentLoaded', () => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js